// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
      wm-modal-get-directions {
        ion-label {
          display: block;
          text-align: center;
          margin: 16px;
          padding-top: 10px;
        }
        ion-list {
          ion-item {
            ion-button {
              width: 100%;
              height: 45px;
              text-transform: none;
              font-size: 14px;
              margin-bottom: 16px;
              --box-shadow: none;
              --border-radius: 25px;

              ion-icon {
                margin-right: 12px;
              }
            }
          }
        }
      }
    `, "",{"version":3,"sources":["webpack://./src/app/shared/wm-core/projects/wm-core/src/modal-get-directions/modal-get-directions.component.ts"],"names":[],"mappings":";MACM;QACE;UACE,cAAc;UACd,kBAAkB;UAClB,YAAY;UACZ,iBAAiB;QACnB;QACA;UACE;YACE;cACE,WAAW;cACX,YAAY;cACZ,oBAAoB;cACpB,eAAe;cACf,mBAAmB;cACnB,kBAAkB;cAClB,qBAAqB;;cAErB;gBACE,kBAAkB;cACpB;YACF;UACF;QACF;MACF","sourcesContent":["\n      wm-modal-get-directions {\n        ion-label {\n          display: block;\n          text-align: center;\n          margin: 16px;\n          padding-top: 10px;\n        }\n        ion-list {\n          ion-item {\n            ion-button {\n              width: 100%;\n              height: 45px;\n              text-transform: none;\n              font-size: 14px;\n              margin-bottom: 16px;\n              --box-shadow: none;\n              --border-radius: 25px;\n\n              ion-icon {\n                margin-right: 12px;\n              }\n            }\n          }\n        }\n      }\n    "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
